<template>
  <div>
    <p class="text-h6">アンケート</p>
    <validation-observer
      ref="observer"
      v-slot="{ invalid }"
    >
      <v-form @submit.prevent="clickSend">
        <v-alert
          v-if="questionnaire_answer_at"
          border="left"
          colored-border
          type="warning"
          elevation="2"
          style="font-size: 90%"
        >
          既に回答済みです。（回答日：{{questionnaire_answer_at}}）再送信する場合は、回答を修正し送信ボタンを押下してください。
        </v-alert>
        <div
          v-for="(pQuestion, index) in parentQuestionList"
          :key="pQuestion.id"
        >
          <v-row>
            <v-col cols="12" sm="7" class="pb-0 pb-sm-3">
              <v-card outlined tile color="blue lighten-5" class="question_card">
                <v-card-text>
                  <v-row align="center" class="mx-0">
                    <div class="py-3" style="font-size:1.2rem">Q{{index+1}}.</div>
                    <v-spacer></v-spacer>
                    <v-chip v-if="pQuestion.is_required" label small color="secondary">
                      必須
                    </v-chip>
                    <v-chip v-else label small color="secondary" outlined>
                      任意
                    </v-chip>
                  </v-row>
                  <div class="my-2" style="font-size:1.1rem">
                    <span v-html="pQuestion.question_text"></span>
                  </div>
                  <div class="my-2" style="font-size:0.85rem">{{pQuestion.annotation}}</div>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" sm="5" class="pt-0 pt-sm-3">
              <v-card outlined tile class="answer_card">
                <v-card-text v-if="pQuestion.option_type == 'Multiple'">
                  <validation-provider
                    :name="'Q'+(index+1)+'.'"
                    :rules="setRule(pQuestion)"
                    v-slot="{ errors }"
                  >
                    <div
                      v-for="option in pQuestion.options"
                      :error-messages="errors"
                      :key="option.id"
                    >
                      <v-checkbox
                        :label="option.option_text"
                        :value="option.id"
                        v-model="pQuestion.selectedList"
                        @change="changeParentSelected(pQuestion)"
                        :disabled="isSubmit"
                        class="mt-1"
                        hide-details="auto"
                        dense />
                    </div>
                  </validation-provider>
                </v-card-text>
                <v-card-text v-else-if="pQuestion.option_type == 'JustOne'">
                  <validation-provider
                    :name="'Q'+(index+1)+'.'"
                    :rules="setRule(pQuestion)"
                    v-slot="{ errors }"
                  >
                    <v-radio-group
                      v-model="pQuestion.my_answer[0].option_id"
                      :error-messages="errors"
                      class="mt-1"
                      hide-details="auto"
                    >
                      <v-radio
                        v-for="option in pQuestion.options"
                        :key="option.id"
                        :label="option.option_text"
                        :value="option.id"
                        @change="changeParentJustOne(pQuestion, option.id)"
                        :disabled="isSubmit"
                        dense />
                    </v-radio-group>
                  </validation-provider>
                </v-card-text>
                <v-card-text v-else-if="pQuestion.option_type == 'Number' && isMobile">
                  <validation-provider
                    :name="'Q'+(index+1)+'.'"
                    :rules="setRule(pQuestion)"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      label="回答"
                      v-model="pQuestion.my_answer[0].number"
                      :error-messages="errors"
                      :disabled="isSubmit"
                      hide-details="auto"
                      inputmode="decimal"
                      outlined
                      dense />
                  </validation-provider>
                </v-card-text>
                <v-card-text v-else-if="pQuestion.option_type == 'Number' && !isMobile">
                  <validation-provider
                    :name="'Q'+(index+1)+'.'"
                    :rules="setRule(pQuestion)"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      label="回答"
                      v-model="pQuestion.my_answer[0].number"
                      :error-messages="errors"
                      :disabled="isSubmit"
                      hide-details="auto"
                      type="text"
                      outlined
                      dense />
                  </validation-provider>
                </v-card-text>
                <v-card-text v-else-if="pQuestion.option_type == 'ShortText'">
                  <validation-provider
                    :name="'Q'+(index+1)+'.'"
                    :rules="setRule(pQuestion)"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      label="回答"
                      v-model="pQuestion.my_answer[0].text"
                      :error-messages="errors"
                      :disabled="isSubmit"
                      hide-details="auto"
                      outlined
                      dense />
                  </validation-provider>
                </v-card-text>
                <v-card-text v-else-if="pQuestion.option_type == 'LongText'">
                  <validation-provider
                    :name="'Q'+(index+1)+'.'"
                    :rules="setRule(pQuestion)"
                    v-slot="{ errors }"
                  >
                    <v-textarea
                      label="回答"
                      :value="pQuestion.my_answer[0].text"
                      @input="pQuestion.my_answer[0].text = $event"
                      :error-messages="errors"
                      :disabled="isSubmit"
                      hide-details="auto"
                      outlined
                      dense />
                  </validation-provider>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <!-- 子質問 -->
          <v-row
            v-for="(child, childIndex) in pQuestion.childQuestionList"
            :key="childIndex">
            <v-col cols="12" sm="7" class="pb-0 pb-sm-3">
              <v-card outlined tile color="teal lighten-5" class="question_card">
                <v-card-text>
                  <v-row align="center" class="mx-0">
                    <div class="py-3" style="font-size:1.2rem">Q{{index+1}}-{{childIndex+1}}.</div>
                    <v-spacer></v-spacer>
                    <v-chip v-if="child.is_required" label small color="secondary">
                      必須
                    </v-chip>
                    <v-chip v-else label small color="secondary" outlined>
                      任意
                    </v-chip>
                  </v-row>
                  <div class="my-2" style="font-size:1.1rem">
                    {{child.question_text}}
                  </div>
                  <div class="my-2" style="font-size:0.85rem">{{child.annotation}}</div>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" sm="5">
              <v-card outlined tile class="answer_card">
                <v-card-text>
                  <validation-provider
                    :name="'Q'+(index+1)+'-'+(childIndex+1)+'.'"
                    :rules="child.rule"
                    v-slot="{ errors }"
                  >
                    <v-radio-group
                      v-model="child.my_answer"
                      :error-messages="errors"
                      @change="changeChildSelected(pQuestion, child)"
                      class="mt-1"
                      hide-details="auto"
                    >
                      <v-radio
                        v-for="option in mySelectedCourseList"
                        :key="option.id"
                        :label="option.name"
                        :value="option.id"
                        :disabled="isSubmit"
                        dense />
                    </v-radio-group>
                  </validation-provider>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </div>
        <div class="text-center ma-4">
          <div>
            <span style="display: inline-block;">
              <v-alert
                v-if="invalid"
                border="left"
                colored-border
                type="warning"
                elevation="2"
                style="font-size: 90%"
              >
                未回答の質問があります。
              </v-alert>
            </span>
          </div>
          <v-btn
            v-if="parentQuestionList.length > 0"
            type="submit"
            depressed color="primary"
            :disabled="invalid || isSubmit"
            :loading="isSubmit"
          >
            送信
          </v-btn>
        </div>
      </v-form>
    </validation-observer>

    <!--共通コンポーネント-->
    <SuccessSnackbar ref="snackbar"/>
    <div class="text-center">
      <v-progress-circular v-if="isLoading" indeterminate color="secondary" />
    </div>
  </div>
</template>

<script>
import GraphqlAPI from '../../utils/GraphqlAPI'
import { required, max, min, max_value as maxValue, min_value as minValue, double, regex } from 'vee-validate/dist/rules'
import { localize, extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
import ja from 'vee-validate/dist/locale/ja.json'
import dayjs from 'dayjs'
const SuccessSnackbar = () => import('../util/SuccessSnackbar.vue')

// バリデーションの定義
setInteractionMode('eager')
localize('ja', ja)
extend('required', required)
extend('max', max)
extend('min', min)
extend('max_value', maxValue)
extend('min_value', minValue)
extend('double', double)
extend('decimal_2', {
  ...regex,
  message: '{_field_}は半角数字（小数点第二位まで）で入力してください'
})

const listQuestionQuery = (campaignId) => `
  query listQuestion {
    listQuestion(campaign_id: "${campaignId}") {
      questions {
        annotation
        id
        is_required
        option_type
        lower_limit
        upper_limit
        options {
          course_select
          course_select_required
          id
          option_text
          sort_order
        }
        my_answer {
          course_id
          number
          option_id
          text
        }
        question_text
        sort_order
      }
    }
  }
`

const listQuestion = async (campaignId) => {
  const { data: { listQuestion: data } } = await GraphqlAPI(listQuestionQuery(campaignId))
  return data.questions
}

const listCourseQuery = (campaignId) => `
  query getListCourse {
    listCourse(campaign_id: "${campaignId}") {
      courses {
        id
        name
        complete_course_weight
        complete_advanced_course_weight
        custom_goal_setting
      }
    }
  }
`

const getListCourse = async (campaignId) => {
  const { data: { listCourse: data } } = await GraphqlAPI(listCourseQuery(campaignId))
  return {
    courses: data.courses.map((item) => {
      return {
        id: item.id,
        name: item.name,
        completeCourseWeight: item.complete_course_weight,
        completeAdvancedCourseWeight: item.complete_advanced_course_weight,
        customGoalSetting: item.custom_goal_setting
      }
    })
  }
}

const getCampaignUserQuery = (campaignId) => `
  query getCampaignUser {
    getCampaignUser(campaign_id: "${campaignId}") {
      course
      questionnaire_answer_at
    }
  }
`

const getCampaignUser = async (campaignId) => {
  const { data: { getCampaignUser: data } } = await GraphqlAPI(getCampaignUserQuery(campaignId))
  return {
    course: data.course,
    questionnaire_answer_at: data.questionnaire_answer_at
  }
}

const convertArrayString = (arrayData) => {
  const resArry = arrayData.map(obj1 => {
    if (typeof obj1 === 'object') {
      const resArry2 = Object.keys(obj1).map(key1 => {
        if (typeof obj1[key1] === 'string') {
          return `${key1}: "${obj1[key1]}"`
        } else if (typeof obj1[key1] === 'object') {
          const resArry3 = obj1[key1].map(obj2 => {
            const resArry4 = Object.keys(obj2).map(key2 => {
              if (obj2[key2] === null) {
                return `${key2}: ${obj2[key2]}`
              } else if (key2 === 'number') {
                if (!obj2[key2]) {
                  return `${key2}: null`
                }
                return `${key2}: ${obj2[key2]}`
              } else if (typeof obj2[key2] === 'string') {
                return `${key2}: ${JSON.stringify(obj2[key2])}`
              }
            })
            return `{${resArry4.join(', ')}}`
          })
          return `${key1}: [${resArry3.join(', ')}]`
        }
      })
      return `{${resArry2.join(', ')}}`
    } else {
      return obj1
    }
  })
  return `[${resArry.join(', ')}]`
}

const answerQuestionnaireMutation = (campaignId, answerList) => `
  mutation postAnswerQuestionnaire {
    answerQuestionnaire(
      input: {
        campaign_id: "${campaignId}",
        questions: ${convertArrayString(answerList)}
      }
    ) {
      campaign_id
      questions {
        question_id
        option_answers {
          option_id
          number
          text
          course_id
        }
      }
    }
  }
`

const answerQuestionnaire = async (campaignId, answerList) => {
  const { data: { answerQuestionnaire: data } } = await GraphqlAPI(answerQuestionnaireMutation(campaignId, answerList))
  return {
    campaign_id: data.campaign_id,
    questions: data.questions
  }
}

export default {
  name: 'question',
  components: {
    ValidationProvider,
    ValidationObserver,
    SuccessSnackbar
  },
  data () {
    return {
      parentQuestionList: [],
      answerList: [],
      mySelectedCourseList: [],
      courseMasterList: [],
      isLoading: false,
      isSubmit: false,
      questionnaire_answer_at: null,
      error: '',
      logger: {}
    }
  },
  computed: {
    campaign () {
      return this.$store.getters.getCampaign
    },
    isMobile () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return true
        case 'sm': return true
        case 'md': return false
        case 'lg': return false
        case 'xl': return false
      }
      return false
    }
  },
  created () {
    this.isLoading = true
  },
  async mounted () {
    try {
      const getQuestionList = listQuestion(this.campaign.id)
      const getSelectedCourseList = getListCourse(this.campaign.id)
      const getCampaignUserInfo = getCampaignUser(this.campaign.id)
      const me = this
      Promise.all([getQuestionList, getSelectedCourseList, getCampaignUserInfo])
        .then(function (responce) {
          // questionListの処理
          const questionList = responce[0]
          // 子質問選択肢用のmySelectedCourseListの生成
          const mySelectedCourseIdList = []
          responce[2].course.forEach(mySelectedCourse => {
            responce[1].courses.some(courseMaster => {
              if (mySelectedCourse === courseMaster.id) {
                me.mySelectedCourseList.push(courseMaster)
                mySelectedCourseIdList.push(courseMaster.id)
                return true
              }
            })
          })
          questionList.forEach(question => {
            if (question.option_type === 'JustOne') {
              question.childQuestionList = [] // 子質問
              question.my_answer.forEach(myAnswer => {
                // 親質問回答済みの場合、childQuestionListを生成
                if (myAnswer !== null) {
                  question.options.some(option => {
                    if (option.course_select && myAnswer.option_id === option.id) {
                      // 回答済みのコースを選択しているか
                      const answerCourseId = mySelectedCourseIdList.includes(myAnswer.course_id) ? myAnswer.course_id : null
                      // 子質問生成
                      question.childQuestionList.push({
                        parent_option_id: option.id,
                        is_required: option.course_select_required,
                        question_text: `「${option.option_text}」につながったコースとは？`,
                        annotation: '1コースのみ選択可',
                        my_answer: answerCourseId,
                        rule: option.course_select_required ? 'required' : ''
                      })
                      return true
                    }
                  })
                }
              })
            } else if (question.option_type === 'Multiple') {
              question.selectedList = []
              question.childQuestionList = [] // 子質問
              question.my_answer.forEach(myAnswer => {
                // 選択中であれば、selectedListを生成
                if (myAnswer !== null && myAnswer.option_id !== null) {
                  question.selectedList.push(myAnswer.option_id)
                }
                // 親子質問回答済みの場合、childQuestionListを生成
                if (myAnswer !== null) {
                  question.options.some(option => {
                    if (option.course_select && question.selectedList.includes(option.id) && myAnswer.option_id === option.id) {
                      // 回答済みのコースを選択しているか
                      const answerCourseId = mySelectedCourseIdList.includes(myAnswer.course_id) ? myAnswer.course_id : null
                      // 子質問生成
                      question.childQuestionList.push({
                        parent_option_id: option.id,
                        is_required: option.course_select_required,
                        question_text: `「${option.option_text}」につながったコースとは？`,
                        annotation: '1コースのみ選択可',
                        my_answer: answerCourseId,
                        rule: option.course_select_required ? 'required' : '',
                        sort_order: option.sort_order
                      })
                      return true
                    }
                  })
                  question.childQuestionList.sort(me.childOrderCompare)
                }
              })
            }
          })
          me.parentQuestionList = questionList
          // アンケート最終回答日
          if (responce[2].questionnaire_answer_at) {
            me.questionnaire_answer_at = dayjs.unix(responce[2].questionnaire_answer_at).format('YYYY/MM/DD HH:mm:ss')
          }
          me.isLoading = false
        })
    } catch (e) {
      this.$emit('errorHandling', 'システムエラーが発生しました。' + e.errors[0].message)
      this.$log.debug(e)
    }
  },
  watch: {
  },
  methods: {
    childOrderCompare (a, b) {
      const orderA = a.sort_order
      const orderB = b.sort_order
      let comparison = 0
      if (orderA > orderB) {
        comparison = 1
      } else if (orderA < orderB) {
        comparison = -1
      }
      return comparison
    },
    setRule (question) {
      const ruleList = {}
      if (question.is_required) {
        ruleList.required = true
      }
      if (question.option_type === 'Number') {
        ruleList.decimal_2 = /(^[0-9\-+]+)(?:\.[0-9]{0,2})?$/
      }
      if (question.lower_limit || question.lower_limit === 0) {
        if (question.option_type === 'Number') {
          ruleList.min_value = question.lower_limit
        } else {
          ruleList.min = question.lower_limit
        }
      }
      if (question.upper_limit) {
        if (question.option_type === 'Number') {
          ruleList.max_value = question.upper_limit
        } else {
          ruleList.max = question.upper_limit
        }
      }
      return ruleList
    },
    changeParentJustOne (pQuestion, optionId) {
      pQuestion.childQuestionList = []
      const option = pQuestion.options.find(function (element) {
        return element.id === optionId
      })
      pQuestion.my_answer[0] = {
        option_id: option,
        course_id: null,
        number: null,
        text: null
      }
      if (option && option.course_select) {
        pQuestion.childQuestionList.push({
          parent_option_id: option.id,
          is_required: option.course_select_required,
          question_text: `「${option.option_text}」につながったコースとは？`,
          annotation: '1コースのみ選択可',
          my_answer: null,
          rule: option.course_select_required ? 'required' : ''
        })
      }
    },
    changeParentSelected (pQuestion) {
      pQuestion.childQuestionList = []
      pQuestion.options.forEach(option => {
        const myAnswerOptionList = pQuestion.my_answer.map((obj) => obj.option_id)
        pQuestion.selectedList.forEach(selected => {
          // チェックの追加：my_answerに格納
          if (!myAnswerOptionList.includes(selected)) {
            pQuestion.my_answer.push({
              option_id: selected,
              course_id: null,
              number: null,
              text: null
            })
          }
          // childQuestionListを生成
          if (selected === option.id && option.course_select) {
            const myAnswer = pQuestion.my_answer.find(function (element) {
              return element.option_id === option.id
            })
            pQuestion.childQuestionList.push({
              parent_option_id: option.id,
              is_required: option.course_select_required,
              question_text: `「${option.option_text}」につながったコースとは？`,
              annotation: '1コースのみ選択可',
              my_answer: myAnswer.course_id,
              rule: option.course_select_required ? 'required' : ''
            })
          }
        })
        // my_answerから削除
        const filteredMyAnswerArray = pQuestion.my_answer.filter(function (element) {
          return pQuestion.selectedList.includes(element.option_id)
        })
        pQuestion.my_answer = filteredMyAnswerArray
      })
    },
    changeChildSelected (pQuestion, child) {
      // childQuestionで選択した値を、options.course_id に格納する
      const target = pQuestion.my_answer.find(element => {
        return element.option_id === child.parent_option_id
      })
      target.course_id = child.my_answer
    },
    async clickSend () {
      try {
        this.isSubmit = true
        if (this.$refs.observer.validate()) {
          // 親のquestionでループして、QuestionInputをつくる
          const answerList = []
          this.parentQuestionList.forEach(question => {
            answerList.push({
              id: question.id,
              options: question.my_answer
            })
          })
          await answerQuestionnaire(this.campaign.id, answerList)
          const campaignUserInfo = await getCampaignUser(this.campaign.id)
          this.questionnaire_answer_at = dayjs.unix(campaignUserInfo.questionnaire_answer_at).format('YYYY/MM/DD HH:mm:ss')
          await this.$refs.snackbar.open('アンケートが送信されました。')
          this.isSubmit = false
        }
      } catch (e) {
        this.$emit('errorHandling', '回答の送信に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
        this.isSubmit = false
      }
    }
  }
}
</script>

<style lang="scss">
.question_card {
  height: 100%;
}
.answer_card {
  height: 100%;
}
</style>
